import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, isFunction } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as ArrowDownIcon } from '../../../../resources/assets/components/DLS_NavigationDown.svg';
import { GlobalActionsStackContext } from '../../../context/global-actions-stack-context.js';
import { useIsMobileResolution } from '../../../hooks/use-is-mobile-resolution.js';
import { LegendsItems } from './legends-items.js';
import { LegendsPreview } from './legends-preview.js';
function InlineLegendHeader(props) {
    const className = classNames({
        'c-legends__header': true,
        'c-legends__header--open': props.open,
    });
    return (React.createElement("div", { className: className },
        React.createElement("span", { className: "c-legends__header-text", onClick: props.onClick }, MessageService.translate(props.open ? props.hideExpression : props.showExpression)),
        React.createElement(ArrowDownIcon, { className: "c-legends__header-icon", onClick: props.onClick })));
}
function InlineLegend(props) {
    const [elementRef, setElementRef] = useState();
    const globalActionsContext = useContext(GlobalActionsStackContext);
    const isMobileResolution = useIsMobileResolution();
    const refCallback = useCallback((element) => {
        setElementRef(element);
    }, []);
    useEffect(() => {
        if (!isMobileResolution || !globalActionsContext) {
            return;
        }
        const popSecondaryElement = globalActionsContext.pushSecondaryElement(React.createElement("div", { className: "c-legends__global-area", ref: refCallback }));
        return () => {
            if (isFunction(popSecondaryElement)) {
                popSecondaryElement();
            }
        };
    }, [isMobileResolution]);
    const content = (React.createElement(Fragment, null,
        React.createElement(LegendsPreview, { previewAmount: props.previewAmount, showPreview: props.showPreview }),
        React.createElement(InlineLegendHeader, { hideExpression: props.hideExpression, onClick: props.onClick, open: props.open, showExpression: props.showExpression }),
        React.createElement(LegendsItems, { className: props.open ? '' : 'c-legends__items--closed' })));
    if (elementRef) {
        return createPortal(content, elementRef);
    }
    return content;
}
export { InlineLegend, };
//# sourceMappingURL=inline-legend.js.map